import { Stack, Typography } from "@mui/material";
import { TitledSection } from "components/Classifiers/Common/TitledSection";
import { SchemaBasedJSONViewer } from "components/UI/SchemaBasedJSONViewer";
import { JsonSchemaRoot } from "components/JsonSchema/types";

export interface ExtractedMetadataItem {
    key: string | number;
    name: string;
    value: unknown;
    jsonSchema?: JsonSchemaRoot;
}

interface ExtractedMetadataListProps {
    items: ExtractedMetadataItem[];
}

export function ExtractedMetadataList({ items }: ExtractedMetadataListProps) {
    return (
        <Stack direction="column" rowGap={1}>
            {items.map((item) => (
                <TitledSection
                    key={item.key}
                    title={item.name}
                    collapsible
                    variant="bordered"
                    maxContentHeight="256px"
                    defaultCollapsed={items.length > 3}
                >
                    {item.jsonSchema ? (
                        <SchemaBasedJSONViewer
                            value={item.value}
                            schema={item.jsonSchema}
                        />
                    ) : (
                        <Typography
                            variant="body2"
                            color={(theme) => theme.palette.gray[700]}
                        >
                            {String(item.value)}
                        </Typography>
                    )}
                </TitledSection>
            ))}
        </Stack>
    );
}
